/*###########################################################################
// Clipboard
//#########################################################################*/

import ClipboardJS from 'clipboard'

window.addEventListener('load', function() {
	const buttons = document.querySelectorAll('.copy-clipboard')

	if (buttons !== null) {
		for (let i = 0; i < buttons.length; i++) {

			let clipboard = new ClipboardJS(buttons[i])

			clipboard.on('success', function (e) {
				let target = buttons[i]

				if (target.getAttribute('data-clipboard-inner') == 'true') {
					const text = target.querySelector('.inner')
					text.innerText = 'Copied link!'

					setTimeout(() => {
						text.innerText = 'Copy'
					}, 2000)
				} else {
					target.innerText = 'Copied link!'

					setTimeout(() => {
						target.innerText = 'Copy'
					}, 2000)
				}
			});

			clipboard.on('error', function (e) {
				console.error('Action:', e.action)
				console.error('Trigger:', e.trigger)
			});
		}
	}
})
